function formatDate(dateValue) {
    if (!dateValue)
        return 'N/A';
    var date = new Date(dateValue);
    if (isNaN(date.getTime()))
        return 'N/A';
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    var hours = String(date.getHours()).padStart(2, '0');
    var minutes = String(date.getMinutes()).padStart(2, '0');
    var seconds = String(date.getSeconds()).padStart(2, '0');
    return day + "-" + month + "-" + year + " " + hours + ":" + minutes + ":" + seconds;
}
function formatTimestamp(timestamp) {
    if (timestamp === undefined || timestamp === null)
        return 'N/A';
    var date = new Date(timestamp);
    var now = new Date();
    var diffMs = now.getTime() - date.getTime();
    var diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 60)
        return diffMins + " minutes ago";
    if (diffMins < 1440)
        return Math.floor(diffMins / 60) + " hours ago";
    return date.toLocaleString();
}
function buildLocationSection(location) {
    if (!location)
        return null;
    var coord = location.coordinate;
    var coordinateNested = {
        header: 'Coordinate',
        content: [
            { label: 'Latitude', value: (coord && coord.lat) ? coord.lat.toFixed(6) : 'N/A' },
            { label: 'Longitude', value: (coord && coord.lng) ? coord.lng.toFixed(6) : 'N/A' }
        ],
        expanded: false,
        isNested: true
    };
    return {
        header: 'Location',
        content: [
            { label: 'Enabled', value: location.enabled ? 'Yes' : 'No' },
            {
                label: 'Coordinate',
                value: 'View Details',
                nested: [coordinateNested]
            },
            { label: 'City', value: location.cityName || 'N/A' },
            { label: 'City ID', value: location.cityId || 'N/A' },
            { label: 'Hex7', value: location.hex7 || 'N/A' },
            { label: 'Hex8', value: location.hex8 || 'N/A' },
            { label: 'Hex9', value: location.hex9 || 'N/A' },
            { label: 'Hex10', value: location.hex10 || 'N/A' },
            { label: 'Updated', value: formatDate(location.updatedAt) || 'N/A' }
        ],
        expanded: false,
        isNested: false
    };
}
function buildServicesSection(services) {
    if (!services || !services.serviceDetails || services.serviceDetails.length === 0) {
        return null;
    }
    var serviceDetailsSections = services.serviceDetails.map(function (service, index) { return ({
        header: index + 1 + ": " + (service.name || service.id),
        content: [
            { label: 'ID', value: service.id || 'N/A' },
            { label: 'Name', value: service.name || 'N/A' },
            {
                label: 'Duration',
                value: service.duration
                    ? new Date(service.duration.start).toLocaleString() + " - " + new Date(service.duration.end).toLocaleString()
                    : 'N/A'
            }
        ],
        expanded: false,
        isNested: true
    }); });
    return {
        header: 'Services',
        content: [
            { label: 'Total Services', value: services.serviceDetails.length.toString() },
            {
                label: 'Service Details',
                value: 'View All',
                nested: serviceDetailsSections
            },
            { label: 'Updated', value: formatTimestamp(services.updatedAt) || 'N/A' }
        ],
        expanded: false,
        isNested: false
    };
}
function buildStatusSection(status) {
    if (!status)
        return null;
    var content = [
        { label: 'Value', value: status.value || 'N/A' },
        { label: 'Updated', value: formatDate(status.updatedAt) || 'N/A' }
    ];
    if (status.softStatus) {
        var softStatusNested = {
            header: 'Soft Status',
            content: [
                { label: 'Value', value: status.softStatus.value || 'N/A' },
                { label: 'Context', value: status.softStatus.context || 'N/A' },
                { label: 'Source', value: status.softStatus.source || 'N/A' }
            ],
            expanded: false,
            isNested: true
        };
        content.push({
            label: 'Soft Status',
            value: 'View Details',
            nested: [softStatusNested]
        });
    }
    return {
        header: 'Status',
        content: content,
        expanded: false,
        isNested: false
    };
}
function buildWayPointsSection(wayPoints) {
    if (!wayPoints || wayPoints.length === 0)
        return null;
    var wayPointSections = wayPoints.map(function (wp, index) {
        var coordinateNested = {
            header: 'Coordinate',
            content: [
                { label: 'Latitude', value: (wp.coordinate && wp.coordinate.lat) ? wp.coordinate.lat.toFixed(6) : 'N/A' },
                { label: 'Longitude', value: (wp.coordinate && wp.coordinate.lng) ? wp.coordinate.lng.toFixed(6) : 'N/A' }
            ],
            expanded: false,
            isNested: true
        };
        return {
            header: (wp.type === 'pickup' ? '📍 Pickup' : '🏁 Drop') + " " + (index + 1),
            content: [
                { label: 'Order ID', value: wp.orderId || 'N/A' },
                { label: 'Service', value: wp.serviceDetailName || wp.serviceDetailId || 'N/A' },
                {
                    label: 'Coordinate',
                    value: 'View Location',
                    nested: [coordinateNested]
                },
                { label: 'Hex7', value: wp.hex7 || 'N/A' },
                { label: 'Hex8', value: wp.hex8 || 'N/A' },
                { label: 'Updated', value: formatDate(wp.updatedAt) || 'N/A' }
            ],
            expanded: false,
            isNested: true
        };
    });
    return {
        header: "Way Points (" + wayPoints.length + ")",
        content: [
            {
                label: 'All Way Points',
                value: wayPoints.length + " points",
                nested: wayPointSections
            }
        ],
        expanded: false,
        isNested: false
    };
}
function buildOnRideBookingSection(onRideBooking) {
    if (!onRideBooking)
        return null;
    var content = [
        { label: 'Enabled', value: onRideBooking.enabled ? 'Yes' : 'No' },
        { label: 'Accept Type', value: onRideBooking.acceptType || 'N/A' },
        { label: 'Updated', value: formatDate(onRideBooking.updatedAt) || 'N/A' }
    ];
    if (onRideBooking.currentOrder) {
        var order = onRideBooking.currentOrder;
        var dropLocationNested = {
            header: 'Drop Location',
            content: [
                {
                    label: 'Latitude',
                    value: (order.dropLocation && order.dropLocation.coordinate && order.dropLocation.coordinate.lat)
                        ? order.dropLocation.coordinate.lat.toFixed(6)
                        : 'N/A'
                },
                {
                    label: 'Longitude',
                    value: (order.dropLocation && order.dropLocation.coordinate && order.dropLocation.coordinate.lng)
                        ? order.dropLocation.coordinate.lng.toFixed(6)
                        : 'N/A'
                },
                { label: 'City', value: (order.dropLocation && order.dropLocation.cityName) ? order.dropLocation.cityName : 'N/A' }
            ],
            expanded: false,
            isNested: true
        };
        var currentOrderNested = {
            header: 'Current Order',
            content: [
                { label: 'Order ID', value: order.orderId || 'N/A' },
                { label: 'Service', value: order.serviceDetailName || order.serviceDetailId || 'N/A' },
                {
                    label: 'Drop Location',
                    value: 'View Location',
                    nested: [dropLocationNested]
                }
            ],
            expanded: false,
            isNested: true
        };
        content.push({
            label: 'Current Order',
            value: 'View Details',
            nested: [currentOrderNested]
        });
    }
    else {
        content.push({ label: 'Current Order', value: 'None' });
    }
    return {
        header: 'On Ride Booking',
        content: content,
        expanded: false,
        isNested: false
    };
}
function buildRoutePreferenceSection(routePreference) {
    if (!routePreference)
        return null;
    var content = [
        { label: 'Exclusive Preferred Routes', value: routePreference.exclusivePreferredRouteOrders ? 'Yes' : 'No' },
        { label: 'Updated', value: formatDate(routePreference.updatedAt) || 'N/A' }
    ];
    if (routePreference.routes && routePreference.routes.length > 0) {
        var routeSections = routePreference.routes.map(function (route, index) { return ({
            header: "Route " + (index + 1),
            content: [
                { label: 'Route ID', value: route.routeID || route._id || 'N/A' },
                { label: 'Enabled', value: route.enabled ? 'Yes' : 'No' },
                { label: 'Enabled At', value: formatDate(route.enabledAt) || 'N/A' },
                { label: 'Enabled Till', value: formatDate(route.enabledTill) || 'N/A' },
                { label: 'Address ID', value: route.addressId || 'N/A' }
            ],
            expanded: false,
            isNested: true
        }); });
        content.push({
            label: 'Routes',
            value: routePreference.routes.length + " routes",
            nested: routeSections
        });
    }
    else {
        content.push({ label: 'Routes', value: 'None' });
    }
    return {
        header: 'Route Preference',
        content: content,
        expanded: false,
        isNested: false
    };
}
function buildMicroCorridorSection(microCorridor) {
    if (!microCorridor)
        return null;
    var content = [
        { label: 'Enabled', value: microCorridor.enabled ? 'Yes' : 'No' },
        { label: 'Updated', value: formatDate(microCorridor.updatedAt) || 'N/A' }
    ];
    if (microCorridor.corridors && microCorridor.corridors.length > 0) {
        var corridorSections = microCorridor.corridors.map(function (corridor, index) { return ({
            header: "Corridor " + (index + 1) + ": " + (corridor.name || corridor.id),
            content: [
                { label: 'ID', value: corridor.id || 'N/A' },
                { label: 'Name', value: corridor.name || 'N/A' },
                { label: 'Service', value: corridor.serviceDetailName || corridor.serviceDetailId || 'N/A' }
            ],
            expanded: false,
            isNested: true
        }); });
        content.push({
            label: 'Corridors',
            value: microCorridor.corridors.length + " corridors",
            nested: corridorSections
        });
    }
    else {
        content.push({ label: 'Corridors', value: 'None' });
    }
    return {
        header: 'Micro Corridor',
        content: content,
        expanded: false,
        isNested: false
    };
}
function buildHailSection(hail) {
    if (!hail)
        return null;
    var content = [
        { label: 'Status', value: hail.status || 'N/A' },
        { label: 'Type', value: hail.type || 'N/A' },
        { label: 'Token', value: hail.token ? hail.token.toString() : 'N/A' },
        { label: 'OTP', value: hail.otp || 'N/A' },
        { label: 'Updated', value: formatDate(hail.updatedAt) || 'N/A' }
    ];
    if (hail.layer) {
        var layerNested = {
            header: 'Layer',
            content: [
                { label: 'Layer ID', value: hail.layer.id || 'N/A' },
                { label: 'Layer Name', value: hail.layer.name || 'N/A' },
                { label: 'Layer Type', value: hail.layer.type || 'N/A' }
            ],
            expanded: false,
            isNested: true
        };
        content.push({
            label: 'Layer',
            value: 'View Details',
            nested: [layerNested]
        });
    }
    if (hail.pickupPoint) {
        var pickupCoordinateNested = {
            header: 'Pickup Coordinate',
            content: [
                {
                    label: 'Latitude',
                    value: (hail.pickupPoint.coordinate && hail.pickupPoint.coordinate.lat)
                        ? hail.pickupPoint.coordinate.lat.toFixed(6)
                        : 'N/A'
                },
                {
                    label: 'Longitude',
                    value: (hail.pickupPoint.coordinate && hail.pickupPoint.coordinate.lng)
                        ? hail.pickupPoint.coordinate.lng.toFixed(6)
                        : 'N/A'
                }
            ],
            expanded: false,
            isNested: true
        };
        var pickupPointNested = {
            header: 'Pickup Point',
            content: [
                { label: 'Name', value: hail.pickupPoint.name || 'N/A' },
                {
                    label: 'Coordinate',
                    value: 'View Location',
                    nested: [pickupCoordinateNested]
                }
            ],
            expanded: false,
            isNested: true
        };
        content.push({
            label: 'Pickup Point',
            value: 'View Details',
            nested: [pickupPointNested]
        });
    }
    return {
        header: 'Hail',
        content: content,
        expanded: false,
        isNested: false
    };
}
function buildFleetSection(fleet) {
    if (!fleet)
        return null;
    return {
        header: 'Fleet',
        content: [
            { label: 'Fleet ID', value: fleet.id || 'N/A' },
            { label: 'Fleet Name', value: fleet.name || 'N/A' },
            { label: 'Type', value: fleet.type || 'N/A' },
            { label: 'Enabled', value: fleet.enabled ? 'Yes' : 'No' },
            { label: 'Updated', value: formatDate(fleet.updatedAt) }
        ],
        expanded: false,
        isNested: false
    };
}
function buildSubscriptionSection(subscription) {
    if (!subscription || !subscription.value || subscription.value.length === 0) {
        return null;
    }
    var subscriptionSections = subscription.value.map(function (sub, index) { return ({
        header: "Subscription " + (index + 1) + ": " + (sub.serviceDetailName || sub.serviceDetailId),
        content: [
            { label: 'Service ID', value: sub.serviceDetailId || 'N/A' },
            { label: 'Service Name', value: sub.serviceDetailName || 'N/A' },
            { label: 'Status', value: sub.status || 'N/A' },
            { label: 'Updated', value: formatDate(sub.updatedAt) }
        ],
        expanded: false,
        isNested: true
    }); });
    return {
        header: 'Subscription',
        content: [
            { label: 'Updated', value: formatDate(subscription.updatedAt) },
            {
                label: 'Subscriptions',
                value: subscription.value.length + " subscriptions",
                nested: subscriptionSections
            }
        ],
        expanded: false,
        isNested: false
    };
}
function buildDeprioritizationSection(deprioritization) {
    if (!deprioritization || !deprioritization.serviceDetails || deprioritization.serviceDetails.length === 0) {
        return null;
    }
    var serviceNames = deprioritization.serviceDetails
        .map(function (s) { return s.name || s.id; })
        .join(', ');
    return {
        header: 'Deprioritization',
        content: [
            { label: 'Services', value: serviceNames },
            { label: 'Updated', value: formatDate(deprioritization.updatedAt) }
        ],
        expanded: false,
        isNested: false
    };
}
function buildReserveSection(reserve) {
    if (!reserve)
        return null;
    var content = [];
    if (reserve.validTill) {
        var validTillDate = new Date(reserve.validTill);
        content.push({ label: 'Valid Till', value: validTillDate.toLocaleString() });
    }
    else {
        content.push({ label: 'Valid Till', value: 'N/A' });
    }
    content.push({ label: 'Updated', value: formatDate(reserve.updatedAt) });
    if (reserve.meta) {
        var metaNested = {
            header: 'Meta',
            content: [
                { label: 'Context', value: reserve.meta.context || 'N/A' },
                { label: 'Source', value: reserve.meta.source || 'N/A' }
            ],
            expanded: false,
            isNested: true
        };
        content.push({
            label: 'Meta',
            value: 'View Details',
            nested: [metaNested]
        });
    }
    return {
        header: 'Reserve',
        content: content,
        expanded: false,
        isNested: false
    };
}
function buildDropLocationPreferenceSection(dropLocationPreference) {
    if (!dropLocationPreference || !dropLocationPreference.preferences || dropLocationPreference.preferences.length === 0) {
        return null;
    }
    var preferenceSections = dropLocationPreference.preferences.map(function (pref, index) { return ({
        header: "Preference " + (index + 1),
        content: [
            { label: 'Layer ID', value: pref.layerId || 'N/A' },
            { label: 'Context', value: pref.context || 'N/A' },
            { label: 'Updated', value: formatDate(pref.updatedAt) }
        ],
        expanded: false,
        isNested: true
    }); });
    return {
        header: 'Drop Location Preference',
        content: [
            { label: 'Updated', value: formatDate(dropLocationPreference.updatedAt) },
            {
                label: 'Preferences',
                value: dropLocationPreference.preferences.length + " preferences",
                nested: preferenceSections
            }
        ],
        expanded: false,
        isNested: false
    };
}
function buildLastMilePreferenceSection(lastMilePreference) {
    if (!lastMilePreference || !lastMilePreference.preferences || lastMilePreference.preferences.length === 0) {
        return null;
    }
    var preferenceSections = lastMilePreference.preferences.map(function (pref, index) {
        var distanceRangeNested = {
            header: 'Distance Range',
            content: [
                {
                    label: 'Min',
                    value: (pref.distanceRangeInMeters && pref.distanceRangeInMeters.min !== null && pref.distanceRangeInMeters.min !== undefined)
                        ? pref.distanceRangeInMeters.min + "m"
                        : 'N/A'
                },
                {
                    label: 'Max',
                    value: (pref.distanceRangeInMeters && pref.distanceRangeInMeters.max !== null && pref.distanceRangeInMeters.max !== undefined)
                        ? pref.distanceRangeInMeters.max + "m"
                        : 'N/A'
                }
            ],
            expanded: false,
            isNested: true
        };
        return {
            header: "Preference " + (index + 1),
            content: [
                { label: 'Mode ID', value: pref.modeId || 'N/A' },
                { label: 'Category ID', value: pref.categoryId || 'N/A' },
                {
                    label: 'Distance Range',
                    value: 'View Range',
                    nested: [distanceRangeNested]
                }
            ],
            expanded: false,
            isNested: true
        };
    });
    return {
        header: 'Last Mile Preference',
        content: [
            { label: 'Updated', value: formatTimestamp(lastMilePreference.updatedAt) || 'N/A' },
            {
                label: 'Preferences',
                value: lastMilePreference.preferences.length + " preferences",
                nested: preferenceSections
            }
        ],
        expanded: false,
        isNested: false
    };
}
var ɵ0 = function (v) { return v || 'N/A'; };
// Root fields: add new entries here when API adds new top-level fields.
// Use (v) => String for plain values, or formatTimestamp/formatDate for dates.
var ROOT_FIELD_CONFIG = [
    { key: 'captainId', label: 'Captain ID', format: ɵ0 },
    { key: 'updatedAt', label: 'Updated At', format: formatDate },
    { key: 'deviceId', label: 'Device ID', format: function (v) { return v || 'N/A'; } },
    { key: 'lastModifiedOn', label: 'Last Modified On', format: formatDate },
    { key: 'lastTimeChangeEventPublishedAt', label: 'Last Time Change Event Published At', format: formatDate }
];
// Section builders keyed by API field name. Add new section = add one builder + one entry here.
var SECTION_BUILDERS = {
    location: buildLocationSection,
    routePreference: buildRoutePreferenceSection,
    microCorridor: buildMicroCorridorSection,
    services: buildServicesSection,
    deprioritization: buildDeprioritizationSection,
    status: buildStatusSection,
    onRideBooking: buildOnRideBookingSection,
    wayPoints: buildWayPointsSection,
    hail: buildHailSection,
    fleet: buildFleetSection,
    subscription: buildSubscriptionSection,
    reserve: buildReserveSection,
    dropLocationPreference: buildDropLocationPreferenceSection,
    lastMilePreference: buildLastMilePreferenceSection
};
export function buildSupplyAttributesData(supplyData) {
    if (!supplyData) {
        return { rootFields: [], sections: [] };
    }
    var rootFields = ROOT_FIELD_CONFIG.map(function (_a) {
        var key = _a.key, label = _a.label, format = _a.format;
        return ({
            label: label,
            value: format(supplyData[key])
        });
    });
    var sections = [];
    for (var _i = 0, _a = Object.entries(SECTION_BUILDERS); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], buildSection = _b[1];
        var section = buildSection(supplyData[key]);
        if (section)
            sections.push(section);
    }
    return { rootFields: rootFields, sections: sections };
}
export { ɵ0 };
